'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { createContext, use, useMemo, useState } from 'react';
import { CartDrawer } from '../molecules/cart-drawer/cart-drawer.tsx';
interface CartDrawerContextValue {
  openCartDrawer: () => void;
  closeCartDrawer: () => void;
}
const CartDrawerContext = createContext<CartDrawerContextValue | null>(null);
export const CartDrawerProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      openCartDrawer: () => setOpen(true),
      closeCartDrawer: () => setOpen(false)
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const value = t1;
  let t2;
  if ($[1] !== open) {
    t2 = <CartDrawer open={open} onOpenChange={setOpen} />;
    $[1] = open;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <CartDrawerContext value={value}>{children}{t2}</CartDrawerContext>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const useCartDrawer = () => {
  const context = use(CartDrawerContext);
  if (!context) {
    throw new Error('useCartDrawer must be used within CartDrawerProvider');
  }
  return context;
};